var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Shimmer',{staticClass:"shimmer",class:[{ highlighted: _vm.isHighlighted }, { 'is-loading': _vm.isLoading }],attrs:{"loading":_vm.isLoading,"border-radius":_vm.isHighlighted ? 'var(--border-radius)' : '0'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }